import type { TFunction } from "i18next"

import { friendlyContactRole } from "./contact-role.ts"
import type { PortalProjectManager } from "../types/portal.types.ts"

export const resolveGcContact = (
  managers: PortalProjectManager[] | undefined
): PortalProjectManager | undefined =>
  managers?.find((m) => m.is_main) ?? managers?.[0]

/** The recipient label shown before an upload submits ("Sharing with ...").
 * Same resolution rule (main manager, else first) used everywhere a project's
 * GC contact needs a human label — Home, Documents, Photos, the upload modal. */
export const resolveRecipientLabel = (
  managers: PortalProjectManager[] | undefined,
  t: TFunction
): string => {
  const contact = resolveGcContact(managers)
  if (!contact) return t("portal.upload.defaultRecipient")
  return `${[contact.first_name, contact.last_name].filter(Boolean).join(" ")} (${friendlyContactRole(contact.role)})`
}
